import React from "react";

const Tradelink = ({ className = "", style = {} }) => {
  // Generate unique IDs to avoid conflicts when multiple instances are rendered
  const uniqueId = Math.random().toString(36).substr(2, 9);
  const primaryGradientId = `primaryGradient-${uniqueId}`;
  const secondaryGradientId = `secondaryGradient-${uniqueId}`;
  const backgroundGradientId = `backgroundGradient-${uniqueId}`;
  const shadowId = `shadow-${uniqueId}`;

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 120 120" 
      width="120" 
      height="120"
      className={className}
      style={style}
    >
      <defs>
        {/* Primary gradient */}
        <linearGradient id={primaryGradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4A90E2" />
          <stop offset="100%" stopColor="#2E5BBA" />
        </linearGradient>
        
        {/* Secondary gradient */}
        <linearGradient id={secondaryGradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7ED321" />
          <stop offset="100%" stopColor="#5BA83B" />
        </linearGradient>
        
        {/* Background circle gradient */}
        <radialGradient id={backgroundGradientId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#F8F9FA" />
          <stop offset="100%" stopColor="#E9ECEF" />
        </radialGradient>
        
        {/* Shadow filter */}
        <filter id={shadowId} x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="2" dy="2" stdDeviation="3" floodColor="rgba(0,0,0,0.2)" />
        </filter>
      </defs>
      
      {/* Background circle */}
      <circle 
        cx="60" 
        cy="60" 
        r="55" 
        fill={`url(#${backgroundGradientId})`} 
        stroke="#DEE2E6" 
        strokeWidth="2"
        filter={`url(#${shadowId})`}
      />
      
      {/* Letter T */}
      <g transform="translate(25, 30)">
        {/* T horizontal bar */}
        <rect 
          x="0" 
          y="0" 
          width="35" 
          height="8" 
          rx="4" 
          fill={`url(#${primaryGradientId})`}
        />
        {/* T vertical bar */}
        <rect 
          x="13.5" 
          y="0" 
          width="8" 
          height="45" 
          rx="4" 
          fill={`url(#${primaryGradientId})`}
        />
      </g>
      
      {/* Letter L */}
      <g transform="translate(70, 30)">
        {/* L vertical bar */}
        <rect 
          x="0" 
          y="0" 
          width="8" 
          height="45" 
          rx="4" 
          fill={`url(#${secondaryGradientId})`}
        />
        {/* L horizontal bar */}
        <rect 
          x="0" 
          y="37" 
          width="25" 
          height="8" 
          rx="4" 
          fill={`url(#${secondaryGradientId})`}
        />
      </g>
      
      {/* Decorative elements */}
      <circle cx="45" cy="85" r="2" fill="#4A90E2" opacity="0.6" />
      <circle cx="55" cy="88" r="1.5" fill="#7ED321" opacity="0.6" />
      <circle cx="65" cy="85" r="2" fill="#4A90E2" opacity="0.6" />
      <circle cx="75" cy="88" r="1.5" fill="#7ED321" opacity="0.6" />
    </svg>
  );
};

export default Tradelink; 